import { DISPLAY_ORDER_NUM } from "../kymw6001.component";
import { ImageDetailListInfo } from "./image_detail_list_info.model";

/**
 * 商品画像情報画面の注文情報、画像情報クラス
 *
 * @export OrderImageListInfo
 * @class OrderImageListInfo
 */
export class OrderImageListInfo {
  constructor(
    // 選択フラグ（追加、更新時の判断用）
    public selectFlg: boolean = false,
    // 注文コード(いばらき)
    public orderNum142: string = '',
    // 注文コード(とちぎ)
    public orderNum163: string = '',
    // 注文コード(ぐんま)
    public orderNum185: string = '',
    // 注文コード(ちば)
    public orderNum240: string = '',
    // 注文コード(さいたま)
    public orderNum210: string = '',
    // 注文コード(とうきょう)
    public orderNum302: string = '',
    // 注文コード(ながの)
    public orderNum515: string = '',
    // 注文コード(にいがた)
    public orderNum451: string = '',
    // 表示用注文コード(いばらき)
    public displayOrderNum142: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 表示用注文コード(とちぎ)
    public displayOrderNum163: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 表示用注文コード(ぐんま)
    public displayOrderNum185: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 表示用注文コード(ちば)
    public displayOrderNum240: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 表示用注文コード(さいたま)
    public displayOrderNum210: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 表示用注文コード(とうきょう)
    public displayOrderNum302: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 表示用注文コード(ながの)
    public displayOrderNum515: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 表示用注文コード(にいがた)
    public displayOrderNum451: string = DISPLAY_ORDER_NUM.NO_SELECTED_COOP,
    // 取扱生協(いばらき)
    public coopFlg142: string = "0",
    // 取扱生協(とちぎ)
    public coopFlg163: string = "0",
    // 取扱生協(ぐんま)
    public coopFlg185: string = "0",
    // 取扱生協(ちば)
    public coopFlg240: string = "0",
    // 取扱生協(さいたま)
    public coopFlg210: string = "0",
    // 取扱生協(とうきょう)
    public coopFlg302: string = "0",
    // 取扱生協(ながの)
    public coopFlg515: string = "0",
    // 取扱生協(にいがた)
    public coopFlg451: string = "0",
    // 画像詳細情報部
    public imageDetailListInfo: ImageDetailListInfo[] = [],
    // 串刺指定
    public skewerSelect: boolean = false,
  ) {}
}
  